import React, { useEffect, useLayoutEffect, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ClearIcon from "@mui/icons-material/Clear";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";

import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Switch,
  Button,
  Select,
  MenuItem,
  SelectChangeEvent,
  Typography,
  Tabs,
  Tab,
  Grid,
  FormControl,
  Autocomplete,
  TextField,
  Popper,
  ClickAwayListener,
  Paper,
  Chip,
  InputAdornment,
  Tooltip,
  Checkbox,
  Collapse,
} from "@mui/material";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Autocomplete as GoogleAutoComplete } from "@react-google-maps/api";

import { useLazyGetAllTypeOfCompaniesQuery } from "../../services/users";

import Pagination from "../../components/Pagination";
import WarnModal from "../../components/WarnModal";
import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";
import Loader from "../../helpers/constants/Loader";
import AddIcon from "@mui/icons-material/Add";
import { useLazyGetAllCategoryQuery } from "../../services/category";
import { Drafts, FilterAlt, FilterAltOff } from "@mui/icons-material";
import { DayPicker } from "react-day-picker";
import moment from "moment";
import {
  useGetPendingPropertyQuery,
  useDeleteByIdPropertyMutation,
  useLazyGetPendingPropertyQuery,
  useDeleteDraftByIdPropertyMutation,
  useLazyGetpropertyTypeOffplanListingQuery,
  useLazyGetAmenitiesListingQuery,
} from "../../services/property";
import { errorToast, successToast } from "../../helpers";
import {
  getEnquriesCount,
  getFeedbackCount,
  getLeadsCount,
  getNewListingActionTracker,
  getNewPropertyReports,
  getNewUsers,
  getRecentNotificationCount,
  setNotificationCount,
} from "../../reducers/generalSlice";
import { useAppDispatch, useAppSelector } from "../../hooks/store";
import CategorySelector from "../../components/CategorySelector";
import EditKeyModal from "../../components/EditWarnModal";
import {
  BOOST_TYPE,
  CATEGORY_TYPE,
  FURNISHED_TYPE,
  LISTING_TYPE,
  OFFER_STATUS,
  PROPERTY_VERIFICATION_STATUS,
  ROLE,
} from "../../constants/enums";
import QualityCriteria from "../../components/QualityScoreModal";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { useVerifyMultiplePropertyMutation } from "../../services/propertyListing";
import RedoIcon from "@mui/icons-material/Redo";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

type filter = {
  Beds: number | string;
  Baths: number | string;
  BoostType: number | string;
  Amenities: string[];
  FurnishingType: number | string;
  RentType: number | string;
  MinSize: number | string;
  MaxSize: number | string;
  Cheque: number | string;
};

type Criteria = {
  complete: string[];
  incomplete: string[];
};

const ManageProperty = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [agencyType, setAgencyType] = useState<any>("");
  const newNotificationCount = useAppSelector(getRecentNotificationCount);
  const newPropertyReports = useAppSelector(getNewPropertyReports);
  const newUsers = useAppSelector(getNewUsers);
  const [shortTerm, setShortTerm] = useState<boolean>(false);
  const newListingActionTracker = useAppSelector(getNewListingActionTracker);
  const newLeadsCount = useAppSelector(getLeadsCount);
  const { state } = useLocation();
  const [rows1, setRows1] = useState<any>([]);
  const [exportCsv] = useLazyGetPendingPropertyQuery();
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount1] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [fetchAllCategory] = useLazyGetAllCategoryQuery();
  const [propertyType, setPropertyType] = useState<string>("");
  const [category, setCategory] = useState<string>("");
  const [price, setPrice] = useState<string>("");
  const [selectedCompany, setSelectedCompany] = useState<string>("");
  const [deleteDraft] = useDeleteDraftByIdPropertyMutation();
  const [selectAll, setSelectAll] = useState(false);
  const [deletePropertyById] = useDeleteByIdPropertyMutation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [companies, setCompanies] = useState<any>([]);
  const [getApprovedCompany] = useLazyGetAllTypeOfCompaniesQuery();
  const [location, setLocation] = useState("");
  const [listingType, setListingType] = useState<number | string>("");
  const [autocomplete, setAutocomplete] = useState(null); // state to store the autocomplete for the google places api
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [latlng, setLatlng] = useState<{ lat: number; lng: number }>({
    lat: 0,
    lng: 0,
  });
  const [amenitiesTypeList] = useLazyGetAmenitiesListingQuery();
  const [qualityScoreData, setQualityScoreData] = useState<Criteria>({
    complete: [],
    incomplete: [],
  });
  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [isBuy, setIsBuy] = useState<boolean>(false);
  const [isRent, setIsRent] = useState<boolean>(false);
  const newEnquries = useAppSelector(getEnquriesCount);
  const newFeedback = useAppSelector(getFeedbackCount);
  const [maxPrice, setMaxPrice] = useState<number | string>("");
  const [minPrice, setMinPrice] = useState<number | string>("");
  const [open1, setOpen1] = useState(false); // Control calendar visibility
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedChip, setSelectedChip] = useState("");
  const [month, setMonth] = useState(new Date());
  const [selectedParentCategory, setSelectedParentCategory] = useState<any>("");
  const [visibleName, setVisibleName] = useState("Select category");

  let totalPages = Math.ceil(totalCount / limit);
  const [showFilter, setShowFilters] = useState<boolean>(false);
  const [properties, setProperties] = useState<{ _id: string; name: string }[]>(
    []
  );
  const [verifyMultipleApi] = useVerifyMultiplePropertyMutation();

  const [propertyTypeList] = useLazyGetpropertyTypeOffplanListingQuery();
  const [categoryDataNew, setCategoryDataNew] = useState<any>([]);
  const [value, setValue] = React.useState(0);
  const [filters, setFilters] = useState<filter>({
    Beds: "",
    Baths: "",
    BoostType: "",
    Amenities: [],
    FurnishingType: "",
    RentType: "",
    MinSize: "",
    MaxSize: "",
    Cheque: "",
  });
  const [openCriteria, setOpenCriteria] = useState<boolean>(false);
  const onCloseCriteria = () => {
    setOpenCriteria(false);
  };
  const [amenity, setAmenity] = useState<{ _id: string; name: string }[]>([
    {
      _id: "",
      name: "",
    },
  ]);

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectAll(event.target.checked);
    setSelectedRows(
      event.target.checked
        ? rows1
            ?.filter(
              (item: any) => item?.qualityScore >= 80 && !item?.isVerified
            )
            .map((r: any) => r._id)
        : []
    );
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setPage(1);
  };
  const onPageChange1 = (newPage: number) => {
    setPage(newPage);
    setRows1([]);
  };
  const [dataCount, setDataCount] = useState({
    publishedRequests: 0, //published
    underOfferRequests: 0, //under offer
    unpublishedRequests: 0, //claimed
    temporaryUnpublish: 0, //unpublished
    xmlUnpublisheProperties: 0, // temporary unpublished
  });

  const handleCategoryReset = () => {
    setSelectedParentCategory("");
    setCategory("");
  };
  const [range, setRange] = useState<{
    from: Date | undefined;
    to: Date | undefined;
  }>({
    from: undefined,
    to: undefined,
  });

  const handleClose = () => {
    setOpen1(false);
  };

  const handleMultipleVerify = async () => {
    const body = {
      verificationRequestStatus: PROPERTY_VERIFICATION_STATUS.APPROVED,
      propertyIds: selectedRows,
    };

    try {
      setIsLoading(true);
      let encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await verifyMultipleApi(encryptedBody).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        setSelectedRows([]);
        successToast("Properties verified successfully");
        refetch();
      }
    } catch (error: any) {
      setIsLoading(false);
      errorToast(error?.data?.message || "");
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen1(true);
  };

  const getFormattedRange = () => {
    if (range?.from && range?.to) {
      return `${moment(range.from).format("MM/DD/YYYY")} - ${moment(
        range.to
      ).format("MM/DD/YYYY")}`;
    } else if (range?.from) {
      return moment(range.from).format("MM/DD/YYYY");
    }
    return "";
  };

  const handleRowCheckboxClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    rowId: string
  ) => {
    if (event.target.checked) {
      setSelectedRows((prevSelected) => [...prevSelected, rowId]);
    } else {
      setSelectedRows((prevSelected) =>
        prevSelected.filter((id) => id !== rowId)
      );
    }
  };

  function formatNumberWithCommas(value: string | number) {
    const valueStr = typeof value === "number" ? value.toFixed(2) : value;
    const [integer, decimal] = valueStr.split(".");
    const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    let result =
      decimal !== undefined
        ? `${formattedInteger}.${decimal}`
        : formattedInteger;
    return result;
  }

  const handleSelect = (selectedRange: any) => {
    if (selectedRange === undefined) {
      setRange({ from: undefined, to: undefined });
    } else {
      setRange(selectedRange);
    }
  };

  const handleChipClick = (value: any) => {
    if (value === selectedChip) {
      setSelectedChip("");
      setRange({ from: undefined, to: undefined });
      setMonth(moment().toDate());
      return;
    }
    setSelectedChip(value);

    let newRange = { from: moment().toDate(), to: moment().toDate() };
    const today = moment();

    if (value === "lastMonth") {
      newRange = {
        from: moment().subtract(1, "months").startOf("month").toDate(),
        to: moment().subtract(1, "months").endOf("month").toDate(),
      };
    } else if (value === "lastWeek") {
      newRange = {
        from: moment().subtract(7, "days").startOf("day").toDate(),
        to: today.toDate(),
      };
    } else if (value === "lastYear") {
      newRange = {
        from: moment().subtract(1, "years").startOf("year").toDate(),
        to: moment().subtract(1, "years").endOf("year").toDate(),
      };
    }
    setRange(newRange);
    setMonth(newRange.from);
  };

  const handleMonthChange = (newMonth: any) => {
    setMonth(newMonth);
  };

  const fetchCompanies = async () => {
    try {
      const response = await getApprovedCompany({
        role: ROLE.AGENCY,
      }).unwrap();
      if (response.statusCode === 200) {
        setCompanies(response?.data || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await fetchAllCategory({
        type: CATEGORY_TYPE.BOTH,
        limit: 100,
      }).unwrap();
      if (response?.statusCode === 200) {
        const data = response?.data.map((item: any) => {
          return {
            categoryName: item._id,
            subCategory: {
              [item._id._id]: item.categories,
            },
          };
        });
        setCategoryDataNew(data);
      }
    } catch (e: any) {
      errorToast(e?.message || e?.data?.message);
    }
  };

  const fetchAmenities = async () => {
    try {
      const response = await amenitiesTypeList({}).unwrap();
      setAmenity(response?.data || []);
    } catch (e: any) {
      errorToast(e?.message || e?.data?.message);
    }
  };

  const fetchPropertyType = async () => {
    try {
      const response = await propertyTypeList({
        isOffPlanProjects: false,
      }).unwrap();
      if (response?.statusCode === 200) {
        setProperties(response?.data || []);
      }
    } catch (e: any) {
      errorToast(e?.message || e?.data?.message);
    }
  };

  const handleAmenities = (event: SelectChangeEvent<string[]>) => {
    if (event?.target?.value) {
      setFilters((prev) => ({
        ...prev,
        Amenities: Array.isArray(event.target.value)
          ? event.target.value
          : [event.target.value],
      }));
    }
  };

  const {
    data,
    isError,
    isLoading: load,
    isSuccess,
    refetch,
  } = useGetPendingPropertyQuery({
    page: page,
    search: debouncedSearchTerm?.trim(),
    limit: limit,
    propertyType: isRent || isBuy ? "" : propertyType,
    category: category,
    categoryParentId: selectedParentCategory,
    price: price,
    companyId: selectedCompany,
    agentId: state?.agentId ? state?.agentId : "",
    propertyName: state?.type ? state?.type : "",
    isDraftSaved: Boolean(searchParams?.get("draft")),
    minPrice: Number(minPrice) || "",
    maxPrice: Number(maxPrice) || "",
    startDate: range?.from
      ? moment(range?.from).startOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]")
      : "",
    endDate:
      range?.from === range?.to
        ? ""
        : range?.to
          ? moment(range?.to).utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
          : "",
    listingType: Number(listingType) || "",
    offerStatus:
      value === 0
        ? OFFER_STATUS.PUBLISHED
        : value === 1
          ? OFFER_STATUS.UNDER_OFFER
          : value === 2
            ? OFFER_STATUS.CLAIMED
            : value === 3
              ? OFFER_STATUS.UNPUBLISHED
              : value === 4
                ? OFFER_STATUS.TEMPORARY_UNPUBLISHED
                : OFFER_STATUS.PUBLISHED,
    lat: Number(latlng?.lat),
    long: Number(latlng?.lng),
    agencyType: agencyType,
    isRent: isRent,
    isBuy: isBuy,
    furnished: Number(filters.FurnishingType),
    boostPlanType: Number(filters.BoostType),
  });

  const handleDeleteProperty = async (userId: any) => {
    try {
      const response = await deletePropertyById({ userId }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Property deleted successfully");
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.message || error?.data?.message || "");
    }
  };

  const handleDeleteDraftProperty = async (userId: any) => {
    try {
      const response = await deleteDraft({ userId }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Property draft deleted successfully");
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.message || error?.data?.message || "");
    }
  };

  const handleExportCsv = async () => {
    try {
      const res = await exportCsv({
        page: page,
        search: debouncedSearchTerm?.trim(),
        limit: limit,
        propertyType: propertyType,
        category: category,
        price: price,
        companyId: selectedCompany,
        agentId: state?.agentId ? state?.agentId : "",
        propertyName: state?.type ? state?.type : "",
        isDraftSaved: Boolean(searchParams?.get("draft")),
        minPrice: Number(minPrice) || "",
        maxPrice: Number(maxPrice) || "",
        startDate: range?.from
          ? moment(range?.from).startOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]")
          : "",
        endDate: range?.to
          ? moment(range?.to).endOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]")
          : "",
        listingType: Number(listingType) || "",
        offerStatus:
          value === 0
            ? 1
            : value === 1
              ? 3
              : value === 2
                ? 2
                : value === 4
                  ? 5
                  : value === 3
                    ? 2
                    : 0,
        lat: Number(latlng?.lat),
        long: Number(latlng?.lng),
        isExport: true,
        agencyType: agencyType,
        furnished: Number(filters.FurnishingType),
        boostPlanType: Number(filters.BoostType),
      }).unwrap();

      if (res?.statusCode === 200) {
        window.open(res?.data);
        successToast("CSV exported successfully");
      } else {
        errorToast("Error: s3Location not found in response");
      }
    } catch (error: any) {
      errorToast(error?.message || error?.data?.message);
    }
  };

  // loading fucntion for the google places api
  const onLoad = (autocompleteObj: any) => {
    setAutocomplete(autocompleteObj);
  };

  // Function to listen the google places api changes
  const onPlaceChanged = async () => {
    if (autocomplete) {
      let place = await (autocomplete as any).getPlace();

      if (place) {
        let lat = place.geometry.location.lat();
        let lng = place.geometry.location.lng();
        setLocation(place?.formatted_address);
        setLatlng({
          lat: lat,
          lng: lng,
        });
      }
    }
  };

  useEffect(() => {
    if (isSuccess && data) {
      const res = data?.data;
      setRows1(res?.property || []);
      setTotalCount1(res?.count);
      setDataCount({
        publishedRequests: res?.publishedRequests || 0,
        underOfferRequests: res?.underOfferRequests || 0,
        unpublishedRequests: res?.unpublishedRequests || 0,
        temporaryUnpublish: res?.temporaryUnpublish || 0,
        xmlUnpublisheProperties: res?.xmlUnpublisheProperties || 0,
      });
    }
  }, [isSuccess, data]);

  const naviagteFun = () => {
    if (shortTerm) {
      navigate(
        `/property-listing/short-term-edit/${selectedId}${Boolean(searchParams?.get("draft")) ? `?draft=true` : ""}`
      );
    } else {
      navigate(
        `/property-listing/edit/${selectedId}${Boolean(searchParams?.get("draft")) ? `?draft=true` : ""}`
      );
    }
  };

  function RowForTab0(props: { row: any; i: number }) {
    const { row, i } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow key={row?.i}>
          <TableCell>
            <Checkbox
              disabled={row?.isVerified || row?.qualityScore < 80}
              // disabled={!(row?.qualityScore < 80 && !row?.isVerified)}
              checked={selectedRows.includes(row?._id)}
              onChange={(event) => handleRowCheckboxClick(event, row?._id)}
            />
          </TableCell>
          <TableCell align="center">{(page - 1) * 10 + i + 1}</TableCell>
          <TableCell align="center">
            <Box className="table_actions">
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
              {!Boolean(searchParams.get("draft")) && (
                <Tooltip title="View Property details">
                  <IconButton
                    onClick={() =>
                      navigate(
                        `/property-listing/details/${row?._id}${Boolean(searchParams?.get("draft")) ? `?draft=true` : ""}`,
                        { state: { tab: 0 } }
                      )
                    }
                  >
                    <VisibilityIcon />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip title="Edit Property">
                <IconButton
                  onClick={() => {
                    setOpenEdit(true);
                    setSelectedId(row?._id);
                    setShortTerm(
                      row?.companyId?.agencyType === 2 ? true : false
                    );
                  }}
                >
                  <ModeEditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Property">
                <IconButton
                  onClick={() => {
                    setOpen(true);
                    setSelectedId(row?._id);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </TableCell>
          <TableCell>{row?.referenceId || "-"}</TableCell>
          <TableCell>{row?.import_reference_number || "-"}</TableCell>
          <TableCell>{row?.advertisementPermitNo || "-"}</TableCell>
          <TableCell align="center">
            <figure className="user_img">
              {row?.isVerified ? (
                <img
                  className="property_badge"
                  src="/static/images/verfy_icon.svg"
                  alt=""
                />
              ) : (
                ""
              )}
              {row?.qualityScore >= 80 ? (
                <img src="/static/images/verify_ico.svg" alt="" />
              ) : (
                ""
              )}
              {row?.isPropertyBoost ? (
                <img src="/static/images/boost.png" alt="" />
              ) : (
                ""
              )}
            </figure>
          </TableCell>
          <TableCell>
            <figure
              onClick={() =>
                navigate(
                  `/property-listing/details/${row?._id}${Boolean(searchParams?.get("draft")) ? `?draft=true` : ""}`,
                  { state: { tab: 0 } }
                )
              }
              className="user_img"
            >
              <img
                style={{ borderRadius: 0 }}
                src={
                  row?.images?.[0]
                    ? row?.images?.[0]
                    : row?.interior?.[0]
                      ? row?.interior?.[0]
                      : `/static/images/product1.png`
                }
                alt=""
              />
            </figure>
          </TableCell>
          <TableCell style={{ minWidth: "220px", textWrap: "wrap" }}>
            {row?.name || "-"}
          </TableCell>
          <TableCell
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (row?.qualityScoreMeetCriteria?.length) {
                setQualityScoreData({
                  complete: row?.qualityScoreMeetCriteria || [],
                  incomplete: row?.qualityScorePendingCriteria || [],
                });
                setOpenCriteria(true);
              }
            }}
          >
            {row?.qualityScore || "-"}
          </TableCell>
          <TableCell>
            {row?.price ? formatNumberWithCommas(String(row?.price)) : "-"}
          </TableCell>
          <TableCell>
            {row?.companyId?.companyName
              ? row?.companyId?.companyName +
                " (" +
                row?.companyId?.referenceId +
                ")"
              : "-"}
          </TableCell>
          <TableCell>
            {row?.userId?.role === 5 || !row?.userId?.role
              ? "-"
              : row?.userId?.name + " (" + row?.userId?.referenceId + ")" ||
                "-"}
          </TableCell>
          <TableCell>
            {row?.listingType ? LISTING_TYPE[row?.listingType] : "-"}
          </TableCell>
          <TableCell>{row?.isPropertyBoost ? "Yes" : "No"}</TableCell>
          <TableCell>{row?.category?.name || "-"}</TableCell>
          <TableCell>{row?.propertyTypes?.name || "-"}</TableCell>
          <TableCell>
            {row?.propertyEndDate
              ? moment(row?.propertyEndDate).format("LLL")
              : "-"}
          </TableCell>
          <TableCell>
            {row?.createdAt ? moment(row?.createdAt).format("LLL") : "-"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ padding: "0 3px" }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box className="collapse_sc agent_collapse">
                <ul>
                  <li>
                    <span>Property Id</span> <strong>{row?.referenceId}</strong>
                  </li>
                  <li>
                    <span>Reference No:</span>{" "}
                    <strong>{row?.import_reference_number || ""}</strong>
                  </li>
                  <li>
                    <span>Permit Number</span>{" "}
                    <strong>{row?.advertisementPermitNo || "-"}</strong>
                  </li>
                  <li>
                    <span>Property Name</span>{" "}
                    <strong>{row?.name || "-"}</strong>
                  </li>
                  <li>
                    <span>Quality Score</span>{" "}
                    <strong> {row?.qualityScore || "-"}</strong>
                  </li>
                  <li>
                    <span>Price</span> <strong>{row?.price || "-"}</strong>
                  </li>
                  <li>
                    <span>Company Name</span>{" "}
                    <strong>
                      {" "}
                      {row?.companyId?.companyName
                        ? row?.companyId?.companyName +
                          " (" +
                          row?.companyId?.referenceId +
                          ")"
                        : "-"}
                    </strong>
                  </li>

                  <li>
                    <span>Agent Name</span>{" "}
                    <strong>
                      {" "}
                      {row?.userId?.role === 5 || !row?.userId?.role
                        ? "-"
                        : row?.userId?.name +
                            " (" +
                            row?.userId?.referenceId +
                            ")" || "-"}
                    </strong>
                  </li>
                  <li>
                    <span>Listing Type</span>{" "}
                    <strong>
                      {" "}
                      {row?.listingType ? LISTING_TYPE[row?.listingType] : "-"}
                    </strong>
                  </li>

                  <li>
                    <span>Boost Property</span>{" "}
                    <strong>{row?.isPropertyBoost ? "Yes" : "No"}</strong>
                  </li>
                  <li>
                    <span>Property Category</span>{" "}
                    <strong>{row?.category?.name || "-"}</strong>
                  </li>
                  <li>
                    <span>Property Type</span>{" "}
                    <strong>{row?.propertyTypes?.name || "-"}</strong>
                  </li>

                  <li>
                    <span>Expiry Date</span>{" "}
                    <strong>
                      {" "}
                      {row?.propertyEndDate
                        ? moment(row?.propertyEndDate).format("LLL")
                        : "-"}
                    </strong>
                  </li>
                  <li>
                    <span>Date & Time</span>{" "}
                    <strong>
                      {" "}
                      {row?.createdAt
                        ? moment(row?.createdAt).format("LLL")
                        : "-"}
                    </strong>
                  </li>
                </ul>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  function RowForTab1(props: { row: any; i: number }) {
    const { row, i } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow key={i}>
          <TableCell align="center">{(page - 1) * 10 + i + 1}</TableCell>
          <TableCell align="center">
            <Box className="table_actions">
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
              {!Boolean(searchParams.get("draft")) && (
                <Tooltip title="View Property details">
                  <IconButton
                    onClick={() =>
                      navigate(
                        `/property-listing/details/${row?._id}${Boolean(searchParams?.get("draft")) ? `?draft=true` : ""}`,
                        { state: { tab: 1 } }
                      )
                    }
                  >
                    <VisibilityIcon />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip title="Edit Property">
                <IconButton
                  onClick={() => {
                    setOpenEdit(true);
                    setSelectedId(row?._id);
                    setShortTerm(
                      row?.companyId?.agencyType === 2 ? true : false
                    );
                  }}
                >
                  <ModeEditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Property">
                <IconButton
                  onClick={() => {
                    setOpen(true);
                    setSelectedId(row?._id);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </TableCell>
          <TableCell>{row?.referenceId || "-"}</TableCell>
          <TableCell>{row?.import_reference_number || "-"}</TableCell>
          <TableCell>{row?.advertisementPermitNo || "-"}</TableCell>
          <TableCell align="center">
            <figure className="user_img">
              {row?.isVerified ? (
                <img
                  className="property_badge"
                  src="/static/images/verfy_icon.svg"
                  alt=""
                />
              ) : (
                ""
              )}
              {row?.qualityScore >= 80 ? (
                <img src="/static/images/verify_ico.svg" alt="" />
              ) : (
                ""
              )}
              {row?.isPropertyBoost ? (
                <img src="/static/images/boost.png" alt="" />
              ) : (
                ""
              )}
            </figure>
          </TableCell>
          <TableCell>
            <figure
              onClick={() =>
                navigate(
                  `/property-listing/details/${row?._id}${Boolean(searchParams?.get("draft")) ? `?draft=true` : ""}`,
                  { state: { tab: 1 } }
                )
              }
              // onClick={() => {
              //   setOpenEdit(true);
              //   setSelectedId(row?._id);
              // }}
              className="user_img"
            >
              <img
                style={{ borderRadius: 0 }}
                src={
                  row?.images?.[0]
                    ? row?.images?.[0]
                    : row?.interior?.[0]
                      ? row?.interior?.[0]
                      : `/static/images/product1.png`
                }
                alt=""
              />
            </figure>
          </TableCell>
          <TableCell style={{ minWidth: "220px", textWrap: "wrap" }}>
            {row?.name || "-"}
          </TableCell>
          <TableCell
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (row?.qualityScoreMeetCriteria?.length) {
                setQualityScoreData({
                  complete: row?.qualityScoreMeetCriteria || [],
                  incomplete: row?.qualityScorePendingCriteria || [],
                });
                setOpenCriteria(true);
              }
            }}
          >
            {row?.qualityScore || "-"}
          </TableCell>
          <TableCell>
            {row?.price ? formatNumberWithCommas(String(row?.price)) : "-"}
          </TableCell>
          <TableCell>
            {row?.underOfferStatus === 1
              ? "Pending"
              : row?.underOfferStatus === 2
                ? "Approved"
                : "-"}
          </TableCell>
          <TableCell>
            {row?.companyId?.companyName
              ? row?.companyId?.companyName +
                " (" +
                row?.companyId?.referenceId +
                ")"
              : "-"}
          </TableCell>
          <TableCell>
            {row?.userId?.role === 5 || !row?.userId?.role
              ? "-"
              : row?.userId?.name + " (" + row?.userId?.referenceId + ")" ||
                "-"}
          </TableCell>
          <TableCell>
            {row?.listingType ? LISTING_TYPE[row?.listingType] : "-"}
          </TableCell>

          <TableCell>{row?.isPropertyBoost ? "Yes" : "No"}</TableCell>
          <TableCell>{row?.category?.name || "-"}</TableCell>
          <TableCell>{row?.propertyTypes?.name || "-"}</TableCell>
          <TableCell>
            {row?.propertyEndDate
              ? moment(row?.propertyEndDate).format("LLL")
              : "-"}
          </TableCell>

          <TableCell>
            {row?.createdAt ? moment(row?.createdAt).format("LLL") : "-"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ padding: "0 3px" }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box className="collapse_sc agent_collapse">
                <ul>
                  <li>
                    <span>Property Id</span> <strong>{row?.referenceId}</strong>
                  </li>
                  <li>
                    <span>Reference No:</span>{" "}
                    <strong>{row?.import_reference_number || ""}</strong>
                  </li>
                  <li>
                    <span>Permit Number</span>{" "}
                    <strong>{row?.advertisementPermitNo || "-"}</strong>
                  </li>
                  <li>
                    <span>Property Name</span>{" "}
                    <strong>{row?.name || "-"}</strong>
                  </li>
                  <li>
                    <span>Quality Score</span>{" "}
                    <strong> {row?.qualityScore || "-"}</strong>
                  </li>
                  <li>
                    <span>Price</span> <strong>{row?.price || "-"}</strong>
                  </li>
                  <li>
                    <span>Company Name</span>{" "}
                    <strong>
                      {" "}
                      {row?.companyId?.companyName
                        ? row?.companyId?.companyName +
                          " (" +
                          row?.companyId?.referenceId +
                          ")"
                        : "-"}
                    </strong>
                  </li>

                  <li>
                    <span>Agent Name</span>{" "}
                    <strong>
                      {" "}
                      {row?.userId?.role === 5 || !row?.userId?.role
                        ? "-"
                        : row?.userId?.name +
                            " (" +
                            row?.userId?.referenceId +
                            ")" || "-"}
                    </strong>
                  </li>
                  <li>
                    <span>Listing Type</span>{" "}
                    <strong>
                      {" "}
                      {row?.listingType ? LISTING_TYPE[row?.listingType] : "-"}
                    </strong>
                  </li>

                  <li>
                    <span>Boost Property</span>{" "}
                    <strong>{row?.isPropertyBoost ? "Yes" : "No"}</strong>
                  </li>
                  <li>
                    <span>Property Category</span>{" "}
                    <strong>{row?.category?.name || "-"}</strong>
                  </li>
                  <li>
                    <span>Property Type</span>{" "}
                    <strong>{row?.propertyTypes?.name || "-"}</strong>
                  </li>

                  <li>
                    <span>Expiry Date</span>{" "}
                    <strong>
                      {" "}
                      {row?.propertyEndDate
                        ? moment(row?.propertyEndDate).format("LLL")
                        : "-"}
                    </strong>
                  </li>
                  <li>
                    <span>Date & Time</span>{" "}
                    <strong>
                      {" "}
                      {row?.createdAt
                        ? moment(row?.createdAt).format("LLL")
                        : "-"}
                    </strong>
                  </li>
                </ul>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  function RowForTab2(props: { row: any; i: number }) {
    const { row, i } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow key={row?.i}>
          <TableCell align="center">{(page - 1) * 10 + i + 1} </TableCell>

          <TableCell>
            <Box className="table_actions">
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
              {!Boolean(searchParams.get("draft")) && (
                <Tooltip title="View Property details">
                  <IconButton
                    onClick={() =>
                      navigate(
                        `/property-listing/details/${row?._id}${Boolean(searchParams?.get("draft")) ? `?draft=true` : ""}`,
                        { state: { tab: 2 } }
                      )
                    }
                  >
                    <VisibilityIcon />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip title="Edit Property">
                <IconButton
                  onClick={() => {
                    setOpenEdit(true);
                    setSelectedId(row?._id);
                    setShortTerm(
                      row?.companyId?.agencyType === 2 ? true : false
                    );
                  }}
                >
                  <ModeEditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Property">
                <IconButton
                  onClick={() => {
                    setOpen(true);
                    setSelectedId(row?._id);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </TableCell>
          <TableCell>{row?.referenceId || "-"}</TableCell>
          <TableCell>{row?.import_reference_number || "-"}</TableCell>
          <TableCell>{row?.advertisementPermitNo || "-"}</TableCell>
          <TableCell align="center">
            <figure className="user_img">
              {row?.isVerified ? (
                <img
                  className="property_badge"
                  src="/static/images/verfy_icon.svg"
                  alt=""
                />
              ) : (
                ""
              )}
              {row?.qualityScore >= 80 ? (
                <img src="/static/images/verify_ico.svg" alt="" />
              ) : (
                ""
              )}
              {row?.isPropertyBoost ? (
                <img src="/static/images/boost.png" alt="" />
              ) : (
                ""
              )}
            </figure>
          </TableCell>
          <TableCell>
            <figure
              onClick={() =>
                navigate(
                  `/property-listing/details/${row?._id}${Boolean(searchParams?.get("draft")) ? `?draft=true` : ""}`,
                  { state: { tab: 2 } }
                )
              }
              className="user_img"
            >
              <img
                style={{ borderRadius: 0 }}
                src={
                  row?.images?.[0]
                    ? row?.images?.[0]
                    : row?.interior?.[0]
                      ? row?.interior?.[0]
                      : `/static/images/product1.png`
                }
                alt=""
              />
            </figure>
          </TableCell>
          <TableCell style={{ minWidth: "220px", textWrap: "wrap" }}>
            {row?.name || "-"}
          </TableCell>
          <TableCell
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (row?.qualityScoreMeetCriteria?.length) {
                setQualityScoreData({
                  complete: row?.qualityScoreMeetCriteria || [],
                  incomplete: row?.qualityScorePendingCriteria || [],
                });
                setOpenCriteria(true);
              }
            }}
          >
            {row?.qualityScore || "-"}
          </TableCell>
          <TableCell>
            {row?.price ? formatNumberWithCommas(String(row?.price)) : "-"}
          </TableCell>
          <TableCell>
            {row?.isClaimDocStatus === 1
              ? "Pending"
              : row?.isClaimDocStatus === 2
                ? "Approved"
                : "-"}
          </TableCell>
          <TableCell>
            {row?.companyId?.companyName
              ? row?.companyId?.companyName +
                " (" +
                row?.companyId?.referenceId +
                ")"
              : "-"}
          </TableCell>
          <TableCell>
            {row?.userId?.role === 5 || !row?.userId?.role
              ? "-"
              : row?.userId?.name + " (" + row?.userId?.referenceId + ")" ||
                "-"}
          </TableCell>
          <TableCell>
            {row?.listingType ? LISTING_TYPE[row?.listingType] : "-"}
          </TableCell>
          <TableCell>{row?.isPropertyBoost ? "Yes" : "No"}</TableCell>
          <TableCell>{row?.category?.name || "-"}</TableCell>
          <TableCell>{row?.propertyTypes?.name || "-"}</TableCell>
          <TableCell>
            {row?.propertyEndDate
              ? moment(row?.propertyEndDate).format("LLL")
              : "-"}
          </TableCell>
          <TableCell>
            {row?.createdAt ? moment(row?.createdAt).format("LLL") : "-"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ padding: "0 3px" }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box className="collapse_sc agent_collapse">
                <ul>
                  <li>
                    <span>Property Id</span> <strong>{row?.referenceId}</strong>
                  </li>
                  <li>
                    <span>Reference No:</span>{" "}
                    <strong>{row?.import_reference_number || ""}</strong>
                  </li>
                  <li>
                    <span>Permit Number</span>{" "}
                    <strong>{row?.advertisementPermitNo || "-"}</strong>
                  </li>
                  <li>
                    <span>Property Name</span>{" "}
                    <strong>{row?.name || "-"}</strong>
                  </li>
                  <li>
                    <span>Quality Score</span>{" "}
                    <strong> {row?.qualityScore || "-"}</strong>
                  </li>
                  <li>
                    <span>Price</span> <strong>{row?.price || "-"}</strong>
                  </li>
                  <li>
                    <span>Company Name</span>{" "}
                    <strong>
                      {" "}
                      {row?.companyId?.companyName
                        ? row?.companyId?.companyName +
                          " (" +
                          row?.companyId?.referenceId +
                          ")"
                        : "-"}
                    </strong>
                  </li>

                  <li>
                    <span>Agent Name</span>{" "}
                    <strong>
                      {" "}
                      {row?.userId?.role === 5 || !row?.userId?.role
                        ? "-"
                        : row?.userId?.name +
                            " (" +
                            row?.userId?.referenceId +
                            ")" || "-"}
                    </strong>
                  </li>
                  <li>
                    <span>Listing Type</span>{" "}
                    <strong>
                      {" "}
                      {row?.listingType ? LISTING_TYPE[row?.listingType] : "-"}
                    </strong>
                  </li>

                  <li>
                    <span>Boost Property</span>{" "}
                    <strong>{row?.isPropertyBoost ? "Yes" : "No"}</strong>
                  </li>
                  <li>
                    <span>Property Category</span>{" "}
                    <strong>{row?.category?.name || "-"}</strong>
                  </li>
                  <li>
                    <span>Property Type</span>{" "}
                    <strong>{row?.propertyTypes?.name || "-"}</strong>
                  </li>

                  <li>
                    <span>Expiry Date</span>{" "}
                    <strong>
                      {" "}
                      {row?.propertyEndDate
                        ? moment(row?.propertyEndDate).format("LLL")
                        : "-"}
                    </strong>
                  </li>
                  <li>
                    <span>Date & Time</span>{" "}
                    <strong>
                      {" "}
                      {row?.createdAt
                        ? moment(row?.createdAt).format("LLL")
                        : "-"}
                    </strong>
                  </li>
                </ul>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  function RowForTab3(props: { row: any; i: number }) {
    const { row, i } = props;

    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow key={row?.i}>
          <TableCell align="center">{(page - 1) * 10 + i + 1}</TableCell>
          <TableCell>
            <Box className="table_actions">
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
              {!Boolean(searchParams.get("draft")) && (
                <Tooltip title="View Property details">
                  <IconButton
                    onClick={() =>
                      navigate(
                        `/property-listing/details/${row?._id}${Boolean(searchParams?.get("draft")) ? `?draft=true` : ""}`,
                        { state: { tab: 2 } }
                      )
                    }
                  >
                    <VisibilityIcon />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip title="Edit Property">
                <IconButton
                  // onClick={() =>
                  //   navigate(
                  //     `/property-listing/edit/${row?._id}${Boolean(searchParams?.get("draft")) ? `?draft=true` : ""}`
                  //   )
                  // }
                  onClick={() => {
                    setOpenEdit(true);
                    setSelectedId(row?._id);
                    setShortTerm(
                      row?.companyId?.agencyType === 2 ? true : false
                    );
                  }}
                >
                  <ModeEditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Property">
                <IconButton
                  onClick={() => {
                    setOpen(true);
                    setSelectedId(row?._id);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </TableCell>
          <TableCell>{row?.referenceId || "-"}</TableCell>
          <TableCell>{row?.import_reference_number || "-"}</TableCell>
          <TableCell>{row?.advertisementPermitNo || "-"}</TableCell>
          <TableCell align="center">
            <figure className="user_img">
              {row?.isVerified ? (
                <img
                  className="property_badge"
                  src="/static/images/verfy_icon.svg"
                  alt=""
                />
              ) : (
                ""
              )}
              {row?.qualityScore >= 80 ? (
                <img src="/static/images/verify_ico.svg" alt="" />
              ) : (
                ""
              )}
              {row?.isPropertyBoost ? (
                <img src="/static/images/boost.png" alt="" />
              ) : (
                ""
              )}
            </figure>
          </TableCell>
          <TableCell>
            <figure
              onClick={() =>
                navigate(
                  `/property-listing/details/${row?._id}${Boolean(searchParams?.get("draft")) ? `?draft=true` : ""}`,
                  { state: { tab: 2 } }
                )
              }
              className="user_img"
            >
              <img
                style={{ borderRadius: 0 }}
                src={
                  row?.images?.[0]
                    ? row?.images?.[0]
                    : row?.interior?.[0]
                      ? row?.interior?.[0]
                      : `/static/images/product1.png`
                }
                alt=""
              />
            </figure>
          </TableCell>
          <TableCell style={{ minWidth: "220px", textWrap: "wrap" }}>
            {row?.name || "-"}
          </TableCell>
          <TableCell
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (row?.qualityScoreMeetCriteria?.length) {
                setQualityScoreData({
                  complete: row?.qualityScoreMeetCriteria || [],
                  incomplete: row?.qualityScorePendingCriteria || [],
                });
                setOpenCriteria(true);
              }
            }}
          >
            {row?.qualityScore || "-"}
          </TableCell>
          <TableCell>
            {row?.price ? formatNumberWithCommas(String(row?.price)) : "-"}
          </TableCell>
          <TableCell>
            {row?.companyId?.companyName
              ? row?.companyId?.companyName +
                " (" +
                row?.companyId?.referenceId +
                ")"
              : "-"}
          </TableCell>
          <TableCell>
            {row?.userId?.role === 5 || !row?.userId?.role
              ? "-"
              : row?.userId?.name + " (" + row?.userId?.referenceId + ")" ||
                "-"}
          </TableCell>
          <TableCell>
            {row?.listingType ? LISTING_TYPE[row?.listingType] : "-"}
          </TableCell>

          <TableCell>{row?.isPropertyBoost ? "Yes" : "No"}</TableCell>
          <TableCell>{row?.category?.name || "-"}</TableCell>
          <TableCell>{row?.propertyTypes?.name || "-"}</TableCell>
          <TableCell>
            {row?.propertyEndDate
              ? moment(row?.propertyEndDate).format("LLL")
              : "-"}
          </TableCell>

          <TableCell>
            {row?.createdAt ? moment(row?.createdAt).format("LLL") : "-"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ padding: "0 3px" }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box className="collapse_sc agent_collapse">
                <ul>
                  <li>
                    <span>Property Id</span> <strong>{row?.referenceId}</strong>
                  </li>
                  <li>
                    <span>Reference No:</span>{" "}
                    <strong>{row?.import_reference_number || ""}</strong>
                  </li>
                  <li>
                    <span>Permit Number</span>{" "}
                    <strong>{row?.advertisementPermitNo || "-"}</strong>
                  </li>
                  <li>
                    <span>Property Name</span>{" "}
                    <strong>{row?.name || "-"}</strong>
                  </li>
                  <li>
                    <span>Quality Score</span>{" "}
                    <strong> {row?.qualityScore || "-"}</strong>
                  </li>
                  <li>
                    <span>Price</span> <strong>{row?.price || "-"}</strong>
                  </li>
                  <li>
                    <span>Company Name</span>{" "}
                    <strong>
                      {" "}
                      {row?.companyId?.companyName
                        ? row?.companyId?.companyName +
                          " (" +
                          row?.companyId?.referenceId +
                          ")"
                        : "-"}
                    </strong>
                  </li>

                  <li>
                    <span>Agent Name</span>{" "}
                    <strong>
                      {" "}
                      {row?.userId?.role === 5 || !row?.userId?.role
                        ? "-"
                        : row?.userId?.name +
                            " (" +
                            row?.userId?.referenceId +
                            ")" || "-"}
                    </strong>
                  </li>
                  <li>
                    <span>Listing Type</span>{" "}
                    <strong>
                      {" "}
                      {row?.listingType ? LISTING_TYPE[row?.listingType] : "-"}
                    </strong>
                  </li>

                  <li>
                    <span>Boost Property</span>{" "}
                    <strong>{row?.isPropertyBoost ? "Yes" : "No"}</strong>
                  </li>
                  <li>
                    <span>Property Category</span>{" "}
                    <strong>{row?.category?.name || "-"}</strong>
                  </li>
                  <li>
                    <span>Property Type</span>{" "}
                    <strong>{row?.propertyTypes?.name || "-"}</strong>
                  </li>

                  <li>
                    <span>Expiry Date</span>{" "}
                    <strong>
                      {" "}
                      {row?.propertyEndDate
                        ? moment(row?.propertyEndDate).format("LLL")
                        : "-"}
                    </strong>
                  </li>
                  <li>
                    <span>Date & Time</span>{" "}
                    <strong>
                      {" "}
                      {row?.createdAt
                        ? moment(row?.createdAt).format("LLL")
                        : "-"}
                    </strong>
                  </li>
                </ul>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  function RowForTab4(props: { row: any; i: number }) {
    const { row, i } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow key={row?.i}>
          <TableCell align="center">{(page - 1) * 10 + i + 1}</TableCell>
          <TableCell>
            <Box className="table_actions">
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
              {!Boolean(searchParams.get("draft")) && (
                <Tooltip title="View Property details">
                  <IconButton
                    onClick={() =>
                      navigate(
                        `/property-listing/details/${row?._id}${Boolean(searchParams?.get("draft")) ? `?draft=true` : ""}`,
                        { state: { tab: 2 } }
                      )
                    }
                  >
                    <VisibilityIcon />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip title="Edit Property">
                <IconButton
                  onClick={() => {
                    setOpenEdit(true);
                    setSelectedId(row?._id);
                    setShortTerm(
                      row?.companyId?.agencyType === 2 ? true : false
                    );
                  }}
                >
                  <ModeEditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Property">
                <IconButton
                  onClick={() => {
                    setOpen(true);
                    setSelectedId(row?._id);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </TableCell>
          <TableCell>{row?.referenceId || "-"}</TableCell>
          <TableCell>{row?.import_reference_number || "-"}</TableCell>
          <TableCell>{row?.advertisementPermitNo || "-"}</TableCell>
          <TableCell align="center">
            <figure className="user_img">
              {row?.isVerified ? (
                <img
                  className="property_badge"
                  src="/static/images/verfy_icon.svg"
                  alt=""
                />
              ) : (
                ""
              )}
              {row?.qualityScore >= 80 ? (
                <img src="/static/images/verify_ico.svg" alt="" />
              ) : (
                ""
              )}
              {row?.isPropertyBoost ? (
                <img src="/static/images/boost.png" alt="" />
              ) : (
                ""
              )}
            </figure>
          </TableCell>
          <TableCell>
            <figure
              onClick={() =>
                navigate(
                  `/property-listing/details/${row?._id}${Boolean(searchParams?.get("draft")) ? `?draft=true` : ""}`,
                  { state: { tab: 2 } }
                )
              }
              className="user_img"
            >
              <img
                style={{ borderRadius: 0 }}
                src={
                  row?.images?.[0]
                    ? row?.images?.[0]
                    : row?.interior?.[0]
                      ? row?.interior?.[0]
                      : `/static/images/product1.png`
                }
                alt=""
              />
            </figure>
          </TableCell>
          <TableCell style={{ minWidth: "220px", textWrap: "wrap" }}>
            {row?.name || "-"}
          </TableCell>
          <TableCell
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (row?.qualityScoreMeetCriteria?.length) {
                setQualityScoreData({
                  complete: row?.qualityScoreMeetCriteria || [],
                  incomplete: row?.qualityScorePendingCriteria || [],
                });
                setOpenCriteria(true);
              }
            }}
          >
            {row?.qualityScore || "-"}
          </TableCell>
          <TableCell>
            {row?.price ? formatNumberWithCommas(String(row?.price)) : "-"}
          </TableCell>
          <TableCell>
            {row?.companyId?.companyName
              ? row?.companyId?.companyName +
                " (" +
                row?.companyId?.referenceId +
                ")"
              : "-"}
          </TableCell>
          <TableCell>
            {row?.userId?.role === 5 || !row?.userId?.role
              ? "-"
              : row?.userId?.name + " (" + row?.userId?.referenceId + ")" ||
                "-"}
          </TableCell>
          <TableCell>
            {row?.listingType ? LISTING_TYPE[row?.listingType] : "-"}
          </TableCell>

          <TableCell>{row?.isPropertyBoost ? "Yes" : "No"}</TableCell>
          <TableCell>{row?.category?.name || "-"}</TableCell>
          <TableCell>{row?.propertyTypes?.name || "-"}</TableCell>
          <TableCell>
            {row?.propertyEndDate
              ? moment(row?.propertyEndDate).format("LLL")
              : "-"}
          </TableCell>

          <TableCell>
            {row?.createdAt ? moment(row?.createdAt).format("LLL") : "-"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ padding: "0 3px" }} colSpan={20}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box className="collapse_sc agent_collapse">
                <ul>
                  <li>
                    <span>Property Id</span> <strong>{row?.referenceId}</strong>
                  </li>
                  <li>
                    <span>Reference No:</span>{" "}
                    <strong>{row?.import_reference_number || ""}</strong>
                  </li>
                  <li>
                    <span>Permit Number</span>{" "}
                    <strong>{row?.advertisementPermitNo || "-"}</strong>
                  </li>
                  <li>
                    <span>Property Name</span>{" "}
                    <strong>{row?.name || "-"}</strong>
                  </li>
                  <li>
                    <span>Quality Score</span>{" "}
                    <strong> {row?.qualityScore || "-"}</strong>
                  </li>
                  <li>
                    <span>Price</span> <strong>{row?.price || "-"}</strong>
                  </li>
                  <li>
                    <span>Company Name</span>{" "}
                    <strong>
                      {" "}
                      {row?.companyId?.companyName
                        ? row?.companyId?.companyName +
                          " (" +
                          row?.companyId?.referenceId +
                          ")"
                        : "-"}
                    </strong>
                  </li>

                  <li>
                    <span>Agent Name</span>{" "}
                    <strong>
                      {" "}
                      {row?.userId?.role === 5 || !row?.userId?.role
                        ? "-"
                        : row?.userId?.name +
                            " (" +
                            row?.userId?.referenceId +
                            ")" || "-"}
                    </strong>
                  </li>
                  <li>
                    <span>Listing Type</span>{" "}
                    <strong>
                      {" "}
                      {row?.listingType ? LISTING_TYPE[row?.listingType] : "-"}
                    </strong>
                  </li>

                  <li>
                    <span>Boost Property</span>{" "}
                    <strong>{row?.isPropertyBoost ? "Yes" : "No"}</strong>
                  </li>
                  <li>
                    <span>Property Category</span>{" "}
                    <strong>{row?.category?.name || "-"}</strong>
                  </li>
                  <li>
                    <span>Property Type</span>{" "}
                    <strong>{row?.propertyTypes?.name || "-"}</strong>
                  </li>

                  <li>
                    <span>Expiry Date</span>{" "}
                    <strong>
                      {" "}
                      {row?.propertyEndDate
                        ? moment(row?.propertyEndDate).format("LLL")
                        : "-"}
                    </strong>
                  </li>
                  <li>
                    <span>Date & Time</span>{" "}
                    <strong>
                      {" "}
                      {row?.createdAt
                        ? moment(row?.createdAt).format("LLL")
                        : "-"}
                    </strong>
                  </li>
                </ul>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
  useEffect(() => {
    fetchPropertyType();
    fetchCompanies();
    fetchCategories();
    fetchAmenities();
  }, []);

  useLayoutEffect(() => {
    if (state) {
      setValue(state);
    }
  }, []);

  useEffect(() => {
    dispatch(
      setNotificationCount({
        newNotificationCount: newNotificationCount,
        newUsers: newUsers,
        newPropertyListing: 0,
        newPropertyReports: newPropertyReports,
        newListingActionTracker: newListingActionTracker,
        newEnquriesCount: newEnquries,
        newFeedbackCount: newFeedback,
        leadsCount: newLeadsCount,
      })
    );
  }, []);

  return (
    <div>
      <Loader isLoad={load || isLoading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">
            Manage Property Listing{" "}
            {Boolean(searchParams.get("draft")) ? `(Drafts)` : ""}
          </h1>
        </div>
        <Card className="cards">
          <Box className="custom_tabs">
            <Box className="cards_header">
              <SearchBar2
                value={searchTerm}
                searchTerm={searchTerm}
                onCross={() => setSearchTerm("")}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                    setTimeout(() => {
                      setPage(1);
                    }, 1000);
                  }
                }}
              />

              <Box className="cards_header_right">
                <Button
                  className="btn btn_primary"
                  onClick={() => setShowFilters(!showFilter)}
                >
                  {showFilter ? <FilterAltOff /> : <FilterAlt />}
                  {showFilter ? "Hide filters" : "Show filters "}
                </Button>
                {Boolean(searchParams.get("draft")) ? (
                  <Button
                    className="btn btn_primary"
                    onClick={() => {
                      setSearchParams("");
                    }}
                  >
                    <MapsHomeWorkIcon />
                    Properties
                  </Button>
                ) : (
                  <Button
                    className="btn btn_primary"
                    onClick={() => {
                      setSearchParams("draft=true");
                    }}
                  >
                    <Drafts />
                    Drafts
                  </Button>
                )}
                <Button
                  className="btn btn_primary"
                  onClick={() => navigate("/property-listing/add")}
                >
                  <AddIcon />
                  Add Property
                </Button>
                <Button
                  className="btn btn_primary"
                  onClick={() => navigate("/property-listing/short-term-add")}
                >
                  <AddIcon />
                  Add Short-term property
                </Button>

                <Button
                  className="btn btn_primary"
                  onClick={handleExportCsv}
                  disabled={rows1?.length === 0 ? true : false}
                >
                  <FileDownloadIcon /> Export CSV
                </Button>
              </Box>
            </Box>
            {showFilter ? (
              <Box>
                <div className="Filters_div">
                  <div className="childFilter childfilter1">
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={propertyType}
                      // onChange={(e) => setPropertyType(e.target.value)}
                      onChange={(e) => {
                        const selectedProperty = properties?.find(
                          (it: any) => it?._id === e.target.value
                        );

                        if (selectedProperty?.name === "Rent") {
                          setIsRent(true);
                          setIsBuy(false);
                          setPropertyType(e.target.value);
                        } else if (selectedProperty?.name === "Buy") {
                          setIsBuy(true);
                          setIsRent(false);
                          setPropertyType(e.target.value);
                        } else {
                          setPropertyType(e.target.value);
                          setIsRent(false);
                          setIsBuy(false);
                        }
                      }}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select Property Type
                      </MenuItem>
                      {properties?.length > 0
                        ? properties?.map((it: any) => (
                            <MenuItem key={it?._id} value={it?._id}>
                              {it?.name}
                            </MenuItem>
                          ))
                        : ""}
                    </Select>
                  </div>
                  <div className="childFilter ">
                    <CategorySelector
                      categoryData={categoryDataNew}
                      handleReset={handleCategoryReset}
                      category={category}
                      parentCategory={selectedParentCategory}
                      setCategory={setCategory}
                      visibleName={visibleName}
                      setVisibleName={setVisibleName}
                      setParentCategory={setSelectedParentCategory}
                    />
                  </div>

                  <div className="childFilter childfilter1">
                    {/* <Typography className="custom_label">Price</Typography> */}
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={price}
                      onChange={(e) => setPrice(e.target.value)}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select Price
                      </MenuItem>

                      <MenuItem value="3">Low to high </MenuItem>
                      <MenuItem value="4">High to low </MenuItem>
                    </Select>
                  </div>
                  <div className="childFilter childfilter1">
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={listingType}
                      onChange={(e) => setListingType(Number(e.target.value))}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select Listing
                      </MenuItem>

                      <MenuItem value="1">Standard </MenuItem>
                      <MenuItem value="3">Premium</MenuItem>
                      <MenuItem value="2">Featured</MenuItem>
                    </Select>
                  </div>
                </div>
                <div className="Filters_div">
                  <div className="childFilter">
                    {/* <Typography className="custom_label">Company</Typography> */}
                    <Autocomplete
                      options={companies || []}
                      getOptionLabel={(option: any) =>
                        option?.companyName +
                          " (" +
                          option?.referenceId +
                          ")" || ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Company"
                          variant="outlined"
                        />
                      )}
                      value={
                        companies?.find(
                          (it: any) => it?._id === selectedCompany
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        setSelectedCompany(newValue?._id || "");
                      }}
                      isOptionEqualToValue={(option: any, value: any) =>
                        option?._id === value?._id
                      }
                    />
                  </div>
                  <div className="childFilter control_group">
                    <GoogleAutoComplete
                      onLoad={onLoad}
                      onPlaceChanged={onPlaceChanged}
                      options={{
                        types: ["political"],
                        componentRestrictions: { country: "ae" },
                      }}
                    >
                      <TextField
                        className="text_field"
                        hiddenLabel
                        name="address"
                        placeholder="Address"
                        value={location}
                        fullWidth
                        inputProps={{
                          maxLength: 100,
                        }}
                        onChange={(val) => {
                          if (
                            val.target.value === " " ||
                            val.target.value === "."
                          ) {
                            setLatlng({
                              lat: 0,
                              lng: 0,
                            });
                          } else {
                            setLocation(val.target.value);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </GoogleAutoComplete>
                    {/* </Select> */}
                  </div>
                  <div className="childFilter control_group  w_25 ">
                    <TextField
                      // label="Select Date Range"
                      variant="outlined"
                      hiddenLabel
                      className="text_field-range "
                      fullWidth
                      onClick={handleClick}
                      value={getFormattedRange()}
                      placeholder="Select Date Range"
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </div>
                  <Popper
                    open={open1}
                    anchorEl={anchorEl}
                    placement="bottom-start"
                    disablePortal
                    style={{
                      position: "relative",
                      zIndex: 1,
                    }}
                  >
                    <ClickAwayListener onClickAway={handleClose}>
                      <Paper
                        elevation={3}
                        style={{ position: "relative", zIndex: 1 }}
                      >
                        <div
                          style={{
                            padding: 8,
                            borderRadius: 10,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-around",
                              padding: "8px",
                            }}
                          >
                            <Chip
                              label="Last Week"
                              variant={
                                selectedChip === "lastWeek"
                                  ? "filled"
                                  : "outlined"
                              }
                              onClick={() => handleChipClick("lastWeek")}
                            />
                            <Chip
                              label="Last Month"
                              variant={
                                selectedChip === "lastMonth"
                                  ? "filled"
                                  : "outlined"
                              }
                              onClick={() => handleChipClick("lastMonth")}
                            />
                            <Chip
                              label="Last Year"
                              variant={
                                selectedChip === "lastYear"
                                  ? "filled"
                                  : "outlined"
                              }
                              onClick={() => handleChipClick("lastYear")}
                            />
                          </div>

                          <DayPicker
                            className="react-day-picker"
                            mode="range"
                            selected={range}
                            onSelect={handleSelect}
                            // numberOfMonths={10}
                            month={month}
                            onMonthChange={handleMonthChange}
                            // styles={{
                            //   months: { display: "flex", gap: "16px" },
                            //   month: { margin: 0 },
                            // }}
                          />
                        </div>
                      </Paper>
                    </ClickAwayListener>
                  </Popper>

                  <div className="childFilter childfilter1">
                    <Select
                      value={filters.Beds}
                      onChange={(e) =>
                        setFilters((prev) => ({
                          ...prev,
                          beds: e.target.value,
                        }))
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select beds
                      </MenuItem>
                      <MenuItem value="0">Studio</MenuItem>
                      <MenuItem value="1">1</MenuItem>
                      <MenuItem value="2">2</MenuItem>
                      <MenuItem value="3">3</MenuItem>
                      <MenuItem value="4">4</MenuItem>
                      <MenuItem value="5">5</MenuItem>
                      <MenuItem value="6">6</MenuItem>
                      <MenuItem value="7">7+</MenuItem>
                    </Select>
                  </div>
                </div>
                <div className="Filters_div">
                  <div className="childFilter childfilter1">
                    <Select
                      value={filters.Baths}
                      onChange={(e) =>
                        setFilters((prev) => ({
                          ...prev,
                          Baths: e.target.value,
                        }))
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select baths
                      </MenuItem>
                      <MenuItem value="0">0</MenuItem>
                      <MenuItem value="1">1</MenuItem>
                      <MenuItem value="2">2</MenuItem>
                      <MenuItem value="3">3</MenuItem>
                      <MenuItem value="4">4</MenuItem>
                      <MenuItem value="5">5</MenuItem>
                      <MenuItem value="6">6</MenuItem>
                      <MenuItem value="7">7+</MenuItem>
                    </Select>
                  </div>

                  <div className="childFilter childfilter1">
                    <Select
                      value={agencyType}
                      onChange={(e) => setAgencyType(e.target.value)}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select company type
                      </MenuItem>
                      <MenuItem value="1">Real estate broker</MenuItem>
                      <MenuItem value="2">Short-term rentals</MenuItem>
                    </Select>
                  </div>
                  <div className="childFilter">
                    <TextField
                      className="text_field"
                      hiddenLabel
                      name="startingPrice"
                      placeholder="Minimum Price"
                      value={minPrice}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          setMinPrice(Number(value));
                        }
                      }}
                      fullWidth
                      inputProps={{
                        maxLength: 10,
                      }}
                    />
                  </div>
                  <div className="childFilter">
                    <TextField
                      className="text_field"
                      hiddenLabel
                      name="startingPrice"
                      placeholder="Maximum Price"
                      value={maxPrice}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          setMaxPrice(Number(value));
                        }
                      }}
                      fullWidth
                      inputProps={{
                        maxLength: 10,
                      }}
                    />
                  </div>
                </div>
                <div className="Filters_div">
                  <div className="childFilter childfilter1">
                    <Select
                      value={filters.BoostType}
                      onChange={(e) =>
                        setFilters((prev) => ({
                          ...prev,
                          BoostType: e.target.value,
                        }))
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select Boost type
                      </MenuItem>
                      <MenuItem value={BOOST_TYPE.APEX}>Apex</MenuItem>
                      <MenuItem value={BOOST_TYPE.ELEVATE}>Elevate</MenuItem>
                      <MenuItem value={BOOST_TYPE.SPOTLIGHT}>
                        Spotlight
                      </MenuItem>
                    </Select>
                  </div>
                  <div className="childFilter childfilter1">
                    <Select
                      value={filters.FurnishingType}
                      onChange={(e) =>
                        setFilters((prev) => ({
                          ...prev,
                          FurnishingType: e.target.value,
                        }))
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select furnishing type
                      </MenuItem>
                      <MenuItem value={FURNISHED_TYPE.FURNISHED}>
                        Furnished
                      </MenuItem>
                      <MenuItem value={FURNISHED_TYPE.UNFURNISHED}>
                        Unfurnished
                      </MenuItem>
                      <MenuItem value={FURNISHED_TYPE.PARTLY_FURNISHED}>
                        Partly Furnished
                      </MenuItem>
                    </Select>
                  </div>
                  <div className="childFilter childfilter1">
                    <Select
                      value={filters.RentType}
                      onChange={(e) =>
                        setFilters((prev) => ({
                          ...prev,
                          RentType: e.target.value,
                        }))
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select rent type
                      </MenuItem>
                      <MenuItem value={1}>Yearly</MenuItem>
                      <MenuItem value={2}>Short term rentals</MenuItem>
                      <MenuItem value={3}>All</MenuItem>
                    </Select>
                  </div>
                  <div className="childFilter childfilter1">
                    <Select
                      value={filters.Cheque}
                      onChange={(e) =>
                        setFilters((prev) => ({
                          ...prev,
                          Cheque: e.target.value,
                        }))
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select No. of Cheque
                      </MenuItem>
                      <MenuItem value="1">Cheque 1</MenuItem>
                      <MenuItem value="2">Cheque 2</MenuItem>
                      <MenuItem value="3">Cheque 3</MenuItem>
                      <MenuItem value="4">Cheque 4</MenuItem>
                    </Select>
                  </div>
                </div>
                <div className="Filters_div">
                  <div className="childFilter">
                    <TextField
                      className="text_field"
                      hiddenLabel
                      placeholder="Min Size"
                      value={filters.MinSize}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          setFilters((prev) => ({ ...prev, MinSize: value }));
                        }
                      }}
                      fullWidth
                      inputProps={{
                        maxLength: 10,
                      }}
                    />
                  </div>
                  <div className="childFilter">
                    <TextField
                      className="text_field"
                      hiddenLabel
                      placeholder="Max Size"
                      value={filters.MaxSize}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          setFilters((prev) => ({ ...prev, MaxSize: value }));
                        }
                      }}
                      fullWidth
                      inputProps={{
                        maxLength: 10,
                      }}
                    />
                  </div>
                  <div className="childFilter">
                    <Select
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250, // Adjust height
                            width: 250, // Adjust width
                          },
                        },
                      }}
                      value={filters.Amenities}
                      onChange={handleAmenities}
                      displayEmpty
                      multiple
                      renderValue={(selected) =>
                        selected?.length > 0
                          ? selected
                              ?.map((value) => {
                                const am = amenity?.find(
                                  (it) => it?._id === value
                                );
                                return am?.name;
                              })
                              .join(", ")
                          : "Select amenities"
                      }
                    >
                      <MenuItem value="" disabled>
                        Select amenities
                      </MenuItem>
                      {amenity?.length > 0
                        ? amenity?.map((it) => (
                            <MenuItem key={it?._id} value={it?._id}>
                              {it?.name}
                            </MenuItem>
                          ))
                        : ""}
                    </Select>
                  </div>
                  {propertyType !== "" ||
                  category !== "" ||
                  price !== "" ||
                  selectedCompany !== "" ||
                  selectedParentCategory !== "" ||
                  maxPrice !== "" ||
                  minPrice !== "" ||
                  listingType !== "" ||
                  latlng.lat !== 0 ||
                  latlng.lng !== 0 ||
                  location !== "" ||
                  agencyType !== "" ||
                  isRent ||
                  isBuy ||
                  range?.from !== undefined ||
                  filters.Beds !== "" ||
                  filters.Baths !== "" ||
                  filters.BoostType !== "" ||
                  filters.BoostType !== "" ||
                  filters.FurnishingType !== "" ||
                  filters.Amenities?.length !== 0 ||
                  filters.RentType !== "" ||
                  filters.MinSize !== "" ||
                  filters.MaxSize !== "" ||
                  range?.to !== undefined ? (
                    <Button
                      className="btn btn_primary"
                      onClick={() => {
                        setPropertyType("");
                        setCategory("");
                        setPrice("");
                        setSelectedCompany("");
                        setMaxPrice("");
                        setMinPrice("");
                        setListingType("");
                        setRange({ from: undefined, to: undefined });
                        setLatlng({ lat: 0, lng: 0 });
                        setLocation("");
                        setAgencyType("");
                        setVisibleName("Select category");
                        setSelectedParentCategory("");
                        setIsBuy(false);
                        setIsRent(false);
                        setFilters({
                          Beds: "",
                          Baths: "",
                          BoostType: "",
                          Amenities: [],
                          FurnishingType: "",
                          RentType: "",
                          MinSize: "",
                          MaxSize: "",
                          Cheque: "",
                        });
                      }}
                    >
                      Clear filters
                    </Button>
                  ) : (
                    ""
                  )}
                </div>
              </Box>
            ) : (
              ""
            )}

            <Box className="custom_tabs" style={{ marginTop: "20px" }}>
              {Boolean(searchParams.get("draft")) ? (
                ""
              ) : (
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="basic tabs example"
                  className="custom_tabs_links"
                >
                  <Tab
                    label={`Published (${dataCount?.publishedRequests})`}
                    {...a11yProps(0)}
                  />
                  <Tab
                    label={`Under Offer (${dataCount?.underOfferRequests})`}
                    {...a11yProps(1)}
                  />
                  <Tab
                    label={`Claimed (${dataCount?.unpublishedRequests})`}
                    {...a11yProps(2)}
                  />
                  <Tab
                    label={`Unpublished (${dataCount?.temporaryUnpublish})`}
                    {...a11yProps(3)}
                  />
                  <Tab
                    label={`Temporary Unpublished (${dataCount?.xmlUnpublisheProperties})`}
                    {...a11yProps(4)}
                  />
                </Tabs>
              )}
              <CustomTabPanel value={value} index={0}>
                <div className="collapse_table">
                  <TableContainer className="table_container" component={Paper}>
                    {selectedRows?.length ? (
                      <Box className="heading">
                        <Button
                          onClick={() => handleMultipleVerify()}
                          className="btn btn_primary"
                          style={{ marginBottom: "10px" }}
                        >
                          Verify Properties
                        </Button>
                      </Box>
                    ) : (
                      ""
                    )}
                    <Table aria-label="collapsible table">
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <Checkbox
                              checked={selectAll}
                              onChange={handleSelectAllClick}
                              inputProps={{ "aria-label": "select all rows" }}
                            />
                          </TableCell>
                          <TableCell align="center">S.No</TableCell>
                          <TableCell align="center">Actions</TableCell>
                          <TableCell>Property Id</TableCell>
                          <TableCell>Reference No.</TableCell>
                          <TableCell>Permit Number</TableCell>
                          <TableCell>Badges</TableCell>
                          <TableCell>Image</TableCell>
                          <TableCell>Property Name</TableCell>
                          <TableCell>Quality Score</TableCell>
                          <TableCell>Price</TableCell>
                          <TableCell>Company Name</TableCell>
                          <TableCell>Agent Name</TableCell>
                          <TableCell>Listing Type</TableCell>
                          <TableCell>Boost Property</TableCell>
                          <TableCell>Property Category</TableCell>
                          <TableCell>Property Type</TableCell>
                          <TableCell>Expiry Date</TableCell>
                          <TableCell>Date & time</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows1.length == 0 ? (
                          <TableRow>
                            <TableCell colSpan={9} align="center">
                              No property found
                            </TableCell>
                          </TableRow>
                        ) : (
                          rows1?.map((row: any, index: number) => (
                            <RowForTab0 key={row?._id} row={row} i={index} />
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </CustomTabPanel>

              <CustomTabPanel value={value} index={1}>
                <div className="collapse_table">
                  <TableContainer className="table_container">
                    <Box className="heading"></Box>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="center">S.No</TableCell>
                          <TableCell align="center">Actions</TableCell>
                          <TableCell>Property Id</TableCell>
                          <TableCell>Reference No.</TableCell>
                          <TableCell>Permit Number</TableCell>
                          <TableCell>Badges</TableCell>
                          <TableCell>Image</TableCell>
                          <TableCell>Property Name</TableCell>
                          <TableCell>Quality Score</TableCell>
                          <TableCell>Price</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Company Name</TableCell>
                          <TableCell>Agent Name</TableCell>
                          <TableCell>Listing Type</TableCell>
                          <TableCell>Boost Property</TableCell>
                          <TableCell>Property Category</TableCell>
                          <TableCell>Property Type</TableCell>
                          <TableCell>Expiry Date</TableCell>

                          <TableCell>Date & time</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows1.length == 0 ? (
                          <TableRow>
                            <TableCell colSpan={9} align="center">
                              No property found
                            </TableCell>
                          </TableRow>
                        ) : (
                          rows1?.map((row: any, index: number) => (
                            <RowForTab1 key={row?._id} row={row} i={index} />
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={2}>
                <div className="collapse_table">
                  <TableContainer className="table_container">
                    <Box className="heading"></Box>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="center">S.No</TableCell>
                          <TableCell align="center">Actions</TableCell>
                          <TableCell>Property Id</TableCell>
                          <TableCell>Reference No.</TableCell>
                          <TableCell>Permit Number</TableCell>
                          <TableCell>Badges</TableCell>
                          <TableCell>Image</TableCell>
                          <TableCell>Property Name</TableCell>
                          <TableCell>Quality Score</TableCell>
                          <TableCell>Price</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Company Name</TableCell>
                          <TableCell>Agent Name</TableCell>
                          <TableCell>Listing Type</TableCell>
                          <TableCell>Boost Property</TableCell>
                          <TableCell>Property Category</TableCell>
                          <TableCell>Property Type</TableCell>
                          <TableCell>Expiry Date</TableCell>

                          <TableCell>Date & time</TableCell>
                          {/* <TableCell>Request</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows1.length == 0 ? (
                          <TableRow>
                            <TableCell colSpan={9} align="center">
                              No property found
                            </TableCell>
                          </TableRow>
                        ) : (
                          rows1?.map((row: any, index: number) => (
                            <RowForTab2 key={row?._id} row={row} i={index} />
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={3}>
                <div className="collapse_table">
                  <TableContainer className="table_container">
                    <Box className="heading"></Box>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="center">S.No</TableCell>
                          <TableCell align="center">Actions</TableCell>
                          <TableCell>Property Id</TableCell>
                          <TableCell>Reference No.</TableCell>
                          <TableCell>Permit Number</TableCell>
                          <TableCell>Badges</TableCell>
                          <TableCell>Image</TableCell>
                          <TableCell>Property Name</TableCell>
                          <TableCell>Quality Score</TableCell>
                          <TableCell>Price</TableCell>
                          <TableCell>Company Name</TableCell>
                          <TableCell>Agent Name</TableCell>
                          <TableCell>Listing Type</TableCell>
                          <TableCell>Boost Property</TableCell>
                          <TableCell>Property Category</TableCell>
                          <TableCell>Property Type</TableCell>
                          <TableCell>Expiry Date</TableCell>

                          <TableCell>Date & time</TableCell>
                          {/* <TableCell>Request</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows1.length == 0 ? (
                          <TableRow>
                            <TableCell colSpan={9} align="center">
                              No property found
                            </TableCell>
                          </TableRow>
                        ) : (
                          rows1?.map((row: any, index: number) => (
                            <RowForTab3 key={row?._id} row={row} i={index} />
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={4}>
                <div className="collapse_table">
                  <TableContainer className="table_container">
                    <Box className="heading"></Box>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="center">S.No</TableCell>
                          <TableCell align="center">Actions</TableCell>
                          <TableCell>Property Id</TableCell>
                          <TableCell>Reference No.</TableCell>
                          <TableCell>Permit Number</TableCell>
                          <TableCell>Badges</TableCell>
                          <TableCell>Image</TableCell>
                          <TableCell>Property Name</TableCell>
                          <TableCell>Quality Score</TableCell>
                          <TableCell>Price</TableCell>
                          <TableCell>Company Name</TableCell>
                          <TableCell>Agent Name</TableCell>
                          <TableCell>Listing Type</TableCell>
                          <TableCell>Boost Property</TableCell>
                          <TableCell>Property Category</TableCell>
                          <TableCell>Property Type</TableCell>
                          <TableCell>Expiry Date</TableCell>

                          <TableCell>Date & time</TableCell>
                          {/* <TableCell>Request</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows1.length == 0 ? (
                          <TableRow>
                            <TableCell colSpan={9} align="center">
                              No property found
                            </TableCell>
                          </TableRow>
                        ) : (
                          rows1?.map((row: any, index: number) => (
                            <RowForTab4 key={row?._id} row={row} i={index} />
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </CustomTabPanel>
            </Box>

            {rows1?.length > 0 ? (
              <Pagination
                setPage={setPage}
                module={rows1}
                page={page}
                onPageChange={onPageChange1}
                totalPages={totalPages}
                limit={limit}
                setLimit={setLimit}
              />
            ) : (
              ""
            )}
            <WarnModal
              open={open}
              setOpen={setOpen}
              handleDelete={() =>
                Boolean(searchParams?.get("draft"))
                  ? handleDeleteDraftProperty(selectedId)
                  : handleDeleteProperty(selectedId)
              }
              name="Property"
            />
            <EditKeyModal
              open={openEdit}
              setOpen={setOpenEdit}
              navigate={naviagteFun}
            />
            <QualityCriteria
              open={openCriteria}
              setOpen={setOpenCriteria}
              onClose={onCloseCriteria}
              data={qualityScoreData}
            />
          </Box>
        </Card>
      </div>
    </div>
  );
};

export default ManageProperty;
